import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { useQueryParamsEnhanced } from "../../../../../helpers/hooks/useQueryParamsEnhanced";

const difficulties = [
	{
		id: "1",
		title: "1 баллов из 10",
	},
	{
		id: "2",
		title: "2 баллов из 10",
	},
	{
		id: "3",
		title: "3 баллов из 10",
	},
	{
		id: "4",
		title: "4 баллов из 10",
	},
	{
		id: "5",
		title: "5 баллов из 10",
	},
	{
		id: "6",
		title: "6 баллов из 10",
	},
	{
		id: "7",
		title: "7 баллов из 10",
	},
	{
		id: "8",
		title: "8 баллов из 10",
	},
	{
		id: "9",
		title: "9 баллов из 10",
	},
	{
		id: "10",
		title: "10 баллов из 10",
	},
];

export default function () {
	const { control } = useFormContext();
	const params = useQueryParamsEnhanced();

	return (
		<Controller
			control={control}
			name={"difficulties"}
			defaultValue={(params["filter[difficulty]"] || []).map((id: string) => difficulties.find((x) => x.id === id))}
			render={({ field: { value, onChange } }) => (
				<Autocomplete
					value={value}
					onChange={(_, value) => onChange(value)}
					multiple
					fullWidth
					loadingText={"Загрузка..."}
					noOptionsText={"Нет опций"}
					disableCloseOnSelect
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							margin={"dense"}
							size={"small"}
							label={"Сложность"}
							placeholder={"Выберите сложность"}
						/>
					)}
					getOptionLabel={(option) => option.title}
					renderTags={(values, getTagProps) =>
						values.map((value, i) => (
							<Chip
								color={"primary"}
								size={"small"}
								variant={"outlined"}
								label={value.title}
								{...getTagProps({ index: i })}
							/>
						))
					}
					renderOption={(props, option) => (
						<li {...props} key={option.title}>
							{option.title}
						</li>
					)}
					options={difficulties}
				/>
			)}
		/>
	);
}
